<template>
  <div>
    <div class="container_box details_box_styles" v-if="warehouseListTalg">
      <!--选择仓库-->
      <div class="select_warehouse_box">
        <h2 class="title">{{ warehouseName }}</h2>
        <Dropdown transfer @on-click="warehouseChange">
          <div class="cursor">
            <span>{{ $t('key1002644') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <template v-for="item in warehouseList">
              <DropdownItem :name="item.ymsWarehouseId">{{ item.name }}</DropdownItem>
            </template>
          </DropdownMenu>
        </Dropdown>
      </div>
      <Form :model="pageParams" :label-width="labelWidth" label-position="right" @submit.native.prevent>
        <!--拣货单设置-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1004720') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :span="twoItemCol">
                <FormItem :label="$t('key1004714')" :label-width="250">
                  <Select v-model="pageParams.singlePrintLocationOrder" style="width: 300px" filterable>
                    <Option v-for="item in packSortList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :span="twoItemCol">
                <FormItem :label="$t('key1004715')" :label-width="250">
                  <Select v-model="pageParams.multiPrintLocationOrder" style="width: 300px" filterable>
                    <Option v-for="item in packSortList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </div>
        <!--集货超时设置-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1004721') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :span="twoItemCol">
                <FormItem :label="$t('key1004716')">
                  <div class="flex align-items-center">
                    <InputNumber :min="1" :max="9999999" v-model="pageParams.storeGoodsTimeOut" style="width: 100px"></InputNumber>
                    <span class="ml8 font-size-12">{{ $t('key1001632') }}</span>
                  </div>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </div>
        <!--包装作业设置-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1004722') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :span="8">
                <Form-item :label="$t('key1004717')" :label-width="145" class="radio_styles">
                  <RadioGroup v-model="pageParams.enableSortingPrinted">
                    <Radio label="Y">{{ $t('key1000392') }}</Radio>
                    <Radio label="N">{{ $t('key1000393') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
              <Col :span="8" v-if="orderComplianceLabelVerificationTalg">
                <Form-item :label="$t('key1004718')" :label-width="160" class="radio_styles">
                  <RadioGroup v-model="pageParams.enableSortingPrintComplianceLabels">
                    <Radio label="Y">{{ $t('key1000392') }}</Radio>
                    <Radio label="N">{{ $t('key1000393') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
              <Col :span="8" v-if="orderComplianceLabelVerificationTalg">
                <Form-item :label="$t('key1004719')" :label-width="160" class="radio_styles">
                  <RadioGroup v-model="pageParams.enablePackagingPrintComplianceLabels">
                    <Radio label="Y">{{ $t('key1000392') }}</Radio>
                    <Radio label="N">{{ $t('key1000393') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
            </Row>
          </Card>
        </div>
      </Form>
      <!--常规分拣架设置-->
      <div class="basic_information_box">
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1004723') }}</h2>
          </template>
          <div style="background:#fff;">
            <Row>
              <Col span="8" style="border-left:1px solid transparent; padding-left: 11px;">
                <div class="flex align-items-center flex-direction">
                  <Checkbox v-model="pickBoxSetting.leftBoxStatus" true-value='Y' false-value='N'>{{ $t('key1004724') }}</Checkbox>
                  <div class="mt20 flex align-items-center">
                    {{ $t('key1004725') }}
                    <Select v-model="pickBoxSetting.leftBoxRow" style="width:50px;margin:0 5px;">
                      <Option v-for="item in lineNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004726') }}
                    <Select v-model="pickBoxSetting.leftBoxCol" style="width:50px;margin:0 5px;">
                      <Option v-for="item in arrangeNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004727') }}
                  </div>
                  <div class="mt20 wp100">
                    <Row class="pick_box_setting" v-for="(item, index) in Number(pickBoxSetting.leftBoxRow)" :key="item">
                      <Col v-for="(i, j) in Number(pickBoxSetting.leftBoxCol)" :key="j">
                        <div class="pickBox">
                          <div style="border-top: 15px solid #ed4014;border-right: 15px solid transparent;float:left;"></div>
                          <div style="text-align:center;margin-top:15px;">{{ 100 + 10 * (index + 1) + (j + 1) }}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span="8" style="border-left:1px solid #d7d7d7; padding-left: 11px;">
                <div class="flex align-items-center flex-direction">
                  <Checkbox v-model="pickBoxSetting.midBoxStatus" true-value='Y' false-value='N'>{{ $t('key1004728') }}</Checkbox>
                  <div class="mt20 flex align-items-center">
                    {{ $t('key1004725') }}
                    <Select v-model="pickBoxSetting.midBoxRow" style="width:50px;margin:0 5px;">
                      <Option v-for="item in lineNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004726') }}
                    <Select v-model="pickBoxSetting.midBoxCol" style="width:50px;margin:0 5px;">
                      <Option v-for="item in arrangeNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004727') }}
                  </div>
                  <div class="mt20 wp100">
                    <Row class="pick_box_setting" v-for="(item, index) in Number(pickBoxSetting.midBoxRow)" :key="item">
                      <Col v-for="(i, j) in Number(pickBoxSetting.midBoxCol)" :key="j">
                        <div class="pickBox">
                          <div style="border-top: 15px solid #ff9900;border-right: 15px solid transparent;float:left;"></div>
                          <div style="text-align:center;marginTop:15px;">{{ 200 + 10 * (index + 1) + (j + 1) }}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span="8" style="border-left:1px solid #d7d7d7; padding-left: 11px;">
                <div class="flex align-items-center flex-direction">
                  <Checkbox v-model="pickBoxSetting.rigBoxStatus" true-value='Y' false-value='N'>{{ $t('key1004729') }}</Checkbox>
                  <div class="mt20 flex align-items-center">
                    {{ $t('key1004725') }}
                    <Select v-model="pickBoxSetting.rigBoxRow" style="width:50px;margin:0 5px;">
                      <Option v-for="item in lineNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004726') }}
                    <Select v-model="pickBoxSetting.rigBoxCol" style="width:50px;margin:0 5px;">
                      <Option v-for="item in arrangeNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004727') }}
                  </div>
                  <div class="mt20 wp100">
                    <Row class="pick_box_setting" v-for="(item, index) in Number(pickBoxSetting.rigBoxRow)" :key="item">
                      <Col v-for="(i, j) in Number(pickBoxSetting.rigBoxCol)" :key="j">
                        <div class="pickBox">
                          <div style="border-top: 15px solid #2db7f5;border-right: 15px solid transparent;float:left;"></div>
                          <div style="text-align:center;marginTop:15px;">{{ 300 + 10 * (index + 1) + (j + 1) }}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
      <!--备货分拣架设置-->
      <div class="basic_information_box">
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1004730') }}</h2>
          </template>
          <div style="background:#fff;">
            <Row>
              <Col span="8" style="border-left:1px solid transparent; padding-left: 11px;">
                <div class="flex align-items-center flex-direction">
                  <Checkbox v-model="choiceBoxSetting.leftBoxStatus" true-value='Y' false-value='N'>{{ $t('key1004724') }}</Checkbox>
                  <div class="mt20 flex align-items-center">
                    {{ $t('key1004725') }}
                    <Select v-model="choiceBoxSetting.leftBoxRow" style="width:50px;margin:0 5px;">
                      <Option v-for="item in lineNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004726') }}
                    <Select v-model="choiceBoxSetting.leftBoxCol" style="width:50px;margin:0 5px;">
                      <Option v-for="item in arrangeNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004727') }}
                  </div>
                  <div class="mt20 wp100">
                    <Row class="pick_box_setting" v-for="(item, index) in Number(choiceBoxSetting.leftBoxRow)" :key="item">
                      <Col v-for="(i, j) in Number(choiceBoxSetting.leftBoxCol)" :key="j">
                        <div class="pickBox">
                          <div style="border-top: 15px solid #ed4014;border-right: 15px solid transparent;float:left;"></div>
                          <div style="text-align:center;margin-top:15px;">{{ 100 + 10 * (index + 1) + (j + 1) }}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span="8" style="border-left:1px solid #d7d7d7; padding-left: 11px;">
                <div class="flex align-items-center flex-direction">
                  <Checkbox v-model="choiceBoxSetting.midBoxStatus" true-value='Y' false-value='N'>{{ $t('key1004728') }}</Checkbox>
                  <div class="mt20 flex align-items-center">
                    {{ $t('key1004725') }}
                    <Select v-model="choiceBoxSetting.midBoxRow" style="width:50px;margin:0 5px;">
                      <Option v-for="item in lineNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004726') }}
                    <Select v-model="choiceBoxSetting.midBoxCol" style="width:50px;margin:0 5px;">
                      <Option v-for="item in arrangeNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004727') }}
                  </div>
                  <div class="mt20 wp100">
                    <Row class="pick_box_setting" v-for="(item, index) in Number(choiceBoxSetting.midBoxRow)" :key="item">
                      <Col v-for="(i, j) in Number(choiceBoxSetting.midBoxCol)" :key="j">
                        <div class="pickBox">
                          <div style="border-top: 15px solid #ff9900;border-right: 15px solid transparent;float:left;"></div>
                          <div style="text-align:center;marginTop:15px;">{{ 200 + 10 * (index + 1) + (j + 1) }}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span="8" style="border-left:1px solid #d7d7d7; padding-left: 11px;">
                <div class="flex align-items-center flex-direction">
                  <Checkbox v-model="choiceBoxSetting.rigBoxStatus" true-value='Y' false-value='N'>{{ $t('key1004729') }}</Checkbox>
                  <div class="mt20 flex align-items-center">
                    {{ $t('key1004725') }}
                    <Select v-model="choiceBoxSetting.rigBoxRow" style="width:50px;margin:0 5px;">
                      <Option v-for="item in lineNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004726') }}
                    <Select v-model="choiceBoxSetting.rigBoxCol" style="width:50px;margin:0 5px;">
                      <Option v-for="item in arrangeNumList" :value="item.value">{{ item.value }}</Option>
                    </Select>
                    {{ $t('key1004727') }}
                  </div>
                  <div class="mt20 wp100">
                    <Row class="pick_box_setting" v-for="(item, index) in Number(choiceBoxSetting.rigBoxRow)" :key="item">
                      <Col v-for="(i, j) in Number(choiceBoxSetting.rigBoxCol)" :key="j">
                        <div class="pickBox">
                          <div style="border-top: 15px solid #2db7f5;border-right: 15px solid transparent;float:left;"></div>
                          <div style="text-align:center;marginTop:15px;">{{ 300 + 10 * (index + 1) + (j + 1) }}</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
      <!--底部操作按钮-->
      <div class="options_content">
        <Button type="primary" @click="saveSetingBtn" v-if="getPermission('erpCommonSettingParam_save')">{{ $t('key1004731') }}</Button>
      </div>
    </div>
    <div v-else>
      <h3 class="flex justify-content-center align-items-center mt100 font-size-22 redColor">{{ $t('key1002664') }}</h3>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getCommonSetting, getEnableWarehouseData, saveErpCommonSettingParam, commonLocalStorage} from "@/utils/common";

export default {
  name: "sortOrderSetting",
  mixins: [Mixin],
  data() {
    return {
      twoItemCol: 12,
      pageParams: {
        singlePrintLocationOrder: '1', // 拣货单设置--单品拣货单打印时货品列表输入顺序
        multiPrintLocationOrder: '1', // 拣货单设置--多品拣货单打印时货品列表输入顺序
        storeGoodsTimeOut: null, // 集货超时设置--集货超时
        enableSortingPrinted: 'N', // 包装作业设置--是否打印
        enableSortingPrintComplianceLabels: 'N', // 包装作业设置--分拣时打印商品合规标签--是否打印合规标签
        enablePackagingPrintComplianceLabels: 'N', // 包装作业设置--包装时打印商品合规标签--是否打印合规标签
      },
      pickBoxSetting: {
        leftBoxStatus: 'Y', // 启用左侧分拣货架
        midBoxStatus: 'Y', // 中间
        rigBoxStatus: 'Y', // 右侧
        leftBoxRow: '4', // 左侧货架行
        leftBoxCol: '5', // 列
        midBoxRow: '4',
        midBoxCol: '5',
        rigBoxRow: '4',
        rigBoxCol: '5'
      },// 常规分拣架设置
      choiceBoxSetting: {
        leftBoxStatus: 'Y', // 启用左侧分拣货架
        midBoxStatus: 'Y', // 中间
        rigBoxStatus: 'Y', // 右侧
        leftBoxRow: '4', // 左侧货架行
        leftBoxCol: '5', // 列
        midBoxRow: '4',
        midBoxCol: '5',
        rigBoxRow: '4',
        rigBoxCol: '5'
      },// 备货分拣架设置
      packSortList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004710'), value: '1'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004711'), value: '2'}
      ],
      lineNumList: [
        {value: '1'},
        {value: '2'},
        {value: '3'},
        {value: '4'},
        {value: '5'},
        {value: '6'},
        {value: '7'},
        {value: '8'},
        {value: '9'},
        {value: '10'},
      ], // 行数
      arrangeNumList: [
        {value: '1'},
        {value: '2'},
        {value: '3'},
        {value: '4'},
        {value: '5'},
        {value: '6'},
        {value: '7'},
        {value: '8'},
        {value: '9'},
        {value: '10'},
      ], // 列数
      warehouseList: [],
      ymsWarehouseId: null,
      warehouseName: ''
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    warehouseListTalg() {
      return this.warehouseList.length > 0;
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  created() {
    this.getYmsWarehouseData();
  },
  methods: {
    // 保存设置 (集货超时的配置存到商户级别，其他配置存到用户级别)
    saveSetingBtn() {
      let v = this;
      let list = [];
      // 分拣设置参数
      let setkeyList = ['singlePrintLocationOrder', 'multiPrintLocationOrder', 'storeGoodsTimeOut',
        'enableSortingPrinted', 'enableSortingPrintComplianceLabels', 'enablePackagingPrintComplianceLabels'];
      for (let key of setkeyList) {
        // 集货超时设置存到商户级别
        if (key === 'storeGoodsTimeOut') {
          list.push({
            paramKey: key,
            paramValue: v.pageParams[key],
            businessId: v.userInfo.merchantId + '*' + v.ymsWarehouseId
          });
        }
        // 其他配置存到用户级别
        else {
          list.push({
            paramKey: key,
            paramValue: v.pageParams[key],
            businessId: v.userInfo.userId + '*' + v.ymsWarehouseId
          });
        }
      }

      // 检验分拣状态是否都为空
      function inspectionStatus(type, data) {
        let obj = {};
        let talg = true;
        for (const key of data) {
          obj[key] = v[type][key];
        }
        if (Object.keys(obj).length > 0) {
          const values = Object.values(obj);
          talg = values.every((item) => {
            return item === 'N';
          });
        }
        return talg;
      }

      let keyList = ['leftBoxStatus', 'midBoxStatus', 'rigBoxStatus'];
      // 常规分拣设置
      if (inspectionStatus('pickBoxSetting', keyList)) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004712'));
        return false;
      } else {
        handleQuery('pickBoxSetting');
      }

      // 备货分拣设置
      if (inspectionStatus('choiceBoxSetting', keyList)) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004713'));
        return false;
      } else {
        handleQuery('choiceBoxSetting');
      }

      // 处理参数
      function handleQuery(type) {
        let obj = {
          pickBoxSetting: {
            enableLeftShelfType: 'leftBoxStatus',
            enableMidShelfType: 'midBoxStatus',
            enableRightShelfType: 'rigBoxStatus',
          },
          choiceBoxSetting: {
            choiceEnableLeftShelfType: 'leftBoxStatus',
            choiceEnableMidShelfType: 'midBoxStatus',
            choiceEnableRightShelfType: 'rigBoxStatus',
          }
        };
        for (let key in obj[type]) {
          list.push({
            paramKey: key,
            paramValue: v[type][obj[type][key]],
            businessId: v.userInfo.userId + '*' + v.ymsWarehouseId
          });
        }

        // 分拣架参数
        let sortingRackObj = {
          pickBoxSetting: {
            leftShelfType: [v[type].leftBoxRow, v[type].leftBoxCol],
            midShelfType: [v[type].midBoxRow, v[type].midBoxCol],
            rightShelfType: [v[type].rigBoxRow, v[type].rigBoxCol],
          },
          choiceBoxSetting: {
            choiceLeftShelfType: [v[type].leftBoxRow, v[type].leftBoxCol],
            choiceMidShelfType: [v[type].midBoxRow, v[type].midBoxCol],
            choiceRightShelfType: [v[type].rigBoxRow, v[type].rigBoxCol],
          }
        };
        for (let key in sortingRackObj[type]) {
          list.push({
            paramKey: key,
            paramValue: sortingRackObj[type][key].join('x'),
            businessId: v.userInfo.userId + '*' + v.ymsWarehouseId
          });
        }
      }

      saveErpCommonSettingParam(list).then(() => {
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
        v.getSetting();
      });
    },
    // 获取设置信息
    getSetting() {
      let v = this;
      if (v.getPermission('erpCommonSettingParam_queryByParam')) {
        // 用户级别的设置
        let userIdKeyList = [
          {
            businessId: v.userInfo.userId + '*' + v.ymsWarehouseId,
            paramKeys: [
              'enableLeftShelfType',
              'enableMidShelfType',
              'enableRightShelfType',

              'choiceEnableLeftShelfType',
              'choiceEnableMidShelfType',
              'choiceEnableRightShelfType',

              'leftShelfType',
              'midShelfType',
              'rightShelfType',

              'choiceLeftShelfType',
              'choiceMidShelfType',
              'choiceRightShelfType',

              'singlePrintLocationOrder', // 拣货单设置--单品拣货单打印时货品列表输入顺序
              'multiPrintLocationOrder', // 拣货单设置--多品拣货单打印时货品列表输入顺序
              'enableSortingPrinted', // 包装作业设置--是否打印

              'enableSortingPrintComplianceLabels', // 包装作业设置--分拣时打印商品合规标签--是否打印合规标签
              'enablePackagingPrintComplianceLabels', // 包装作业设置--包装作业时打印商品合规标签--是否打印合规标签
            ]
          }
        ];
        // 集货超时设置存到商户级别
        let merchantIdKeyList = [
          {
            businessId: v.userInfo.merchantId + '*' + v.ymsWarehouseId,
            paramKeys: ['storeGoodsTimeOut'], // 集货超时设置--集货超时
          }
        ];
        let query = [...userIdKeyList, ...merchantIdKeyList];
        getCommonSetting(query).then((data)=> {
          if (data.length > 0) {
            // 处理分拣架的数据
            function handlePickingShelves(val) {
              // 常规分拣
              let keyList = ['leftShelfType', 'midShelfType', 'rightShelfType'];
              if (keyList.includes(val.paramKey)) {
                let value = val.paramValue.split('x');
                let obj = {
                  leftShelfType: ['leftBoxRow', 'leftBoxCol'],
                  midShelfType: ['midBoxRow', 'midBoxCol'],
                  rightShelfType: ['rigBoxRow', 'rigBoxCol']
                };
                v.pickBoxSetting[obj[val.paramKey][0]] = value[0];
                v.pickBoxSetting[obj[val.paramKey][1]] = value[1];
              }
              // 备货分拣
              let choiceKeyList = ['choiceLeftShelfType', 'choiceMidShelfType', 'choiceRightShelfType'];
              if (choiceKeyList.includes(val.paramKey)) {
                let value = val.paramValue.split('x');
                let choiceObj = {
                  choiceLeftShelfType: ['leftBoxRow', 'leftBoxCol'],
                  choiceMidShelfType: ['midBoxRow', 'midBoxCol'],
                  choiceRightShelfType: ['rigBoxRow', 'rigBoxCol']
                };
                v.choiceBoxSetting[choiceObj[val.paramKey][0]] = value[0];
                v.choiceBoxSetting[choiceObj[val.paramKey][1]] = value[1];
              }
            }

            // 处理分拣架状态的数据
            function handlePickingShelvesStatus(val) {
              // 常规
              let keyList = ['enableLeftShelfType', 'enableMidShelfType', 'enableRightShelfType'];
              let obj = {
                enableLeftShelfType: 'leftBoxStatus',
                enableMidShelfType: 'midBoxStatus',
                enableRightShelfType: 'rigBoxStatus'
              };
              if (keyList.includes(val.paramKey)) {
                v.pickBoxSetting[obj[val.paramKey]] = val.paramValue;
              }
              // 备货
              let choiceKeyList = ['choiceEnableLeftShelfType', 'choiceEnableMidShelfType', 'choiceEnableRightShelfType'];
              let choiceObj = {
                choiceEnableLeftShelfType: 'leftBoxStatus',
                choiceEnableMidShelfType: 'midBoxStatus',
                choiceEnableRightShelfType: 'rigBoxStatus'
              };
              if (choiceKeyList.includes(val.paramKey)) {
                v.choiceBoxSetting[choiceObj[val.paramKey]] = val.paramValue;
              }
            }

            // 处理分拣设置的数据
            function handleSetting(val) {
              let keyList = ['enableSortingPrinted', 'storeGoodsTimeOut', 'singlePrintLocationOrder', 'multiPrintLocationOrder',
                'enableSortingPrintComplianceLabels', 'enablePackagingPrintComplianceLabels'];
              let keyToNumber = ['storeGoodsTimeOut'];
              if (keyList.includes(val.paramKey)) {
                v.pageParams[val.paramKey] = keyToNumber.includes(val.paramKey) ? Number(val.paramValue) : val.paramValue;
              }
            }

            data.map((item) => {
              handlePickingShelves(item);
              handlePickingShelvesStatus(item);
              handleSetting(item);
            });
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取已启用的仓库
    getYmsWarehouseData() {
      getEnableWarehouseData(1).then((data) => {
        if (data.length > 0) {
          this.warehouseList = data;
          this.ymsWarehouseId = data[0].ymsWarehouseId;
          this.warehouseName = data[0].name;
          this.getSetting();
        }
      });
    },
    // 切换仓库
    warehouseChange(value) {
      this.ymsWarehouseId = value;
      this.getSetting();
      this.warehouseList.map((item) => {
        if (item.ymsWarehouseId === value) {
          this.warehouseName = item.name;
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.details_box_styles {
  position: relative;
  padding-bottom: 48px;

  .basic_information_box {
    /deep/ .ivu-form-item {
      margin-bottom: 8px;
    }

    .pick_box_setting {
      display: flex !important;
      flex-wrap: wrap;

      /deep/ .ivu-col {
        flex: 1;
      }

      .pickBox {
        //width: 93px;
        flex: 1;
        height: 50px;
        margin-top: 5px;
        margin-bottom: 5px;
        border: 1px solid #000;
        font-weight: bold;
        margin-right: 11px;
        box-sizing: border-box;
      }

      //.ivu-col:last-child .pickBox {
      //  margin-right: 0 !important;
      //}
    }
  }

  .options_content {
    box-shadow: 0px -3px 10px 0px #c9cbce;
    position: fixed;
    min-width: 100%;
    z-index: 10;
    background-color: #fff;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 15px;
  }

  .select_warehouse_box {
    padding: 10px 0 10px 0px;
    display: flex;
    align-items: center;

    .title {
      color: #333;
      font-size: 20px;
      font-weight: bold;
      margin-right: 25px;
    }
  }
}
</style>
